export function shouldDisableButton(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    );
  });
}